<template>
  <dy-item-wrap :item="item">
    <yjp-input-number v-bind="$attrs" v-on="$listeners" />
  </dy-item-wrap>
</template>

<script>
import DyFormMixin from "../dyformitemMixin";
export default {
  mixins: [DyFormMixin]
};
</script>




// WEBPACK FOOTER //
// NumberWidget.vue?968ca332